
<template>
    <div class="pdfIcons">
        <button
            class="kgr-table__action"
            :disabled="disabled"
            style="position: relative;"
            @click="download()"
        >
            <kgr-icon
                :title="downloadTitle"
                :disabled="disabled"
                icon-class="pdf"
            />
            <i
                v-if="downloaded"
                class="kgr-indicator is-success dot"
            >
            </i>
        </button>
        <button
            :disabled="disabled"
            @click="preview()"
        >
            <kgr-icon
                :title="previewTitle"
                :disabled="disabled"
                icon-class="preview"
            />
        </button>
    </div>
</template>
<script>
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import ClubInvoiceChargebackPdfRepository from '../../../js/repository/ClubInvoiceChargebackPdfRepository.js';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon
    },
    props: {
        invoice: {
            type: ClubInvoice,
            required: true,
        },
    },
    data() {
        return {
            helper: new Helper(),
        }
    },
    computed: {
        disabled() {
            return !this.invoice.chargeback.pdfExists;
        },
        downloadTitle: function () {
            if (!this.invoice.chargeback.pdfExists) {
                return this.$t('Das PDF wird erstellt');
            }
            let title = this.$t('PDF herunterladen');
            if (this.invoice.chargeback.pdfLastDownload) {
                title = title + '\n\nLetzter Download von einem Mitarbeiter am ' + this.formatDate(this.invoice.chargeback.pdfLastDownload);
            }
            if (this.invoice.chargeback.pdfLastDownloadByMember) {
                title = title + '\n\nLetzter Download vom Rechnungsempfänger am ' + this.formatDate(this.invoice.chargeback.pdfLastDownloadByMember);
            }
            return title
        },
        previewTitle: function () {
            if (!this.invoice.chargeback.pdfExists) {
                return this.$t('Das PDF wird erstellt');
            }
            return this.$t('PDF ansehen')
        },
        downloaded() {
            return null !== this.invoice.chargeback.pdfLastDownload;
        }
    },
    methods: {
        download() {
            ClubInvoiceChargebackPdfRepository.createDownloadHistory(this.invoice.id)
                .then(response => {
                    ClubInvoiceChargebackPdfRepository.downloadChargebackPdf(response.headers.location)
                        .then(() => {console.log('then');this.$emit('reloadInvoice');})
                        .catch(() => {console.log('err');this.$notify.error('error.loadingData');});
                });
        },
        formatDate(date) {
            return this.helper.formatDate(date);
        },
        preview() {
            ClubInvoiceChargebackPdfRepository.createDownloadHistory(this.invoice.id)
                .then(response => {
                    window.open(response.headers.location + '?contentDisposition=inline', '_blank');
                    this.$emit('reloadInvoice');
                });
        },
    },
}
</script>

<style>
    div.pdfIcons {
        display: inline-block;
        margin-left: 15px;
    }
    .dot {
        position: absolute;
        top: -3px;
        right: -3px;
    }
</style>
